<template>
    <div class="chat_wrap">
       
        <div></div>
        <chat-room :room_id='room_id' :headerdisplay='true'></chat-room>
    </div>
</template>
<script>
import ChatRoom from '@/mobile/components/chat/ChatRoom.vue';
export default {
    name:'',
    props:{
        room_id:{
            default:'m1'
        }    
    }    
    ,
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{
        ChatRoom
    },
    computed:{
       
    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" >
    .chat_wrap{
        height:100vh
    }
</style>